import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HotContentSection from './components/HotContentSection';
import DownloadSection from './components/DownloadSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="黄瓜视频 - 短视频创作与分享平台"
        description="黄瓜视频是一款专注于短视频创作、分享与发现的平台，提供海量优质视频内容、便捷的剪辑工具和活跃的创作者社区。无论你是内容创作者还是视频爱好者，黄瓜视频都能满足你的需求，立即体验！"
        keywords="黄瓜视频,黄瓜视频下载,黄瓜视频APP,黄瓜视频创作者,短视频平台,视频剪辑工具,短视频分享社区"
        canonicalUrl="https://huanggua.video"
        schemaData={[
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '黄瓜视频',
            url: 'https://huanggua.video',
            description: '黄瓜视频是一款专注于短视频创作、分享与发现的平台',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '黄瓜视频',
            url: 'https://huanggua.video',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: '黄瓜视频是完全免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，黄瓜视频的基本功能完全免费！你可以免费观看所有视频内容、使用基础剪辑工具、参与社区互动。' } },
              { '@type': 'Question', name: '如何在黄瓜视频上发布自己的作品？', acceptedAnswer: { '@type': 'Answer', text: '下载黄瓜视频APP后，注册账号，点击底部"+"号按钮即可开始创作。' } },
              { '@type': 'Question', name: '黄瓜视频支持哪些设备？', acceptedAnswer: { '@type': 'Answer', text: '黄瓜视频目前支持iOS和Android两大主流移动平台。' } },
              { '@type': 'Question', name: '创作者的收益是如何计算的？', acceptedAnswer: { '@type': 'Answer', text: '黄瓜视频为创作者提供多元化的变现方式，包括播放量收益分成、创作者激励计划、粉丝打赏和品牌合作。' } },
              { '@type': 'Question', name: '上传的视频有大小和时长限制吗？', acceptedAnswer: { '@type': 'Answer', text: '基础用户单个视频最大支持500MB，时长上限为15分钟。' } },
              { '@type': 'Question', name: '如何保护我的视频版权？', acceptedAnswer: { '@type': 'Answer', text: '黄瓜视频提供自动水印、原创声明、侵权举报和区块链存证等版权保护措施。' } },
              { '@type': 'Question', name: '遇到技术问题或需要帮助怎么办？', acceptedAnswer: { '@type': 'Answer', text: '可以通过APP内帮助中心、在线客服、官方邮箱和创作者社区获得帮助。' } },
            ],
          },
        ]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <HotContentSection />
        <DownloadSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}